import { Button } from "react-bootstrap";
import PulseLoader from "react-spinners/PulseLoader";

const ReportSubmitButton = ({ disabled, isLoading, children, loaderColor = "#fff", ...props }) => {
  return (
    <button
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <PulseLoader
          color={loaderColor}
          loading={isLoading}
          // cssOverride={override}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ):(
        children
      )}
    </button>
  );
};

export default ReportSubmitButton;